import styled from 'styled-components';

export const Page = styled.div`
    flex: 5;
    padding: 20px;
`;